import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Step } from '../../../state/map';

interface StepIndicatorProps {
  step: Step;
  stepNumber: number;
  isActive: boolean;
  onClick: () => void;
}

const stepLabels: Record<Step, string> = {
  [Step.Location]: 'Location',
  [Step.Pins]: 'Pins', 
  [Step.Style]: 'Style',
  [Step.Layout]: 'Layers',
  [Step.Border]: 'Border',
  [Step.Size]: 'Size',
};

const StepIndicator: React.FC<StepIndicatorProps> = ({ 
  step, 
  stepNumber, 
  isActive, 
  onClick 
}) => {
  const theme = useTheme();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '8px 12px',
        borderRadius: '20px',
        backgroundColor: 'transparent',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        }
      }}
    >
      <Box
        sx={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          backgroundColor: isActive 
            ? theme.palette.primary.contrastText 
            : theme.palette.primary.main,
          color: isActive 
            ? theme.palette.primary.main 
            : theme.palette.primary.contrastText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          fontWeight: 600,
          marginRight: '8px'
        }}
      >
        {stepNumber}
      </Box>
      <Typography
        variant="body2"
        sx={{
          color: isActive 
            ? theme.palette.primary.contrastText 
            : theme.palette.text.primary,
          fontWeight: isActive ? 600 : 400,
          fontSize: '14px'
        }}
      >
        {stepLabels[step]}
      </Typography>
    </Box>
  );
};

export default StepIndicator;
